import React, { createContext, useContext, useRef } from "react";
import NotificationAlert from "react-notification-alert";
import { useTranslation } from "context/TranslationProvider";
import helpers from "utils/helpers";

const NotificationContext = createContext();

const {
  NOTIFICATION_PLACE,
  NOTIFICATION_TYPE,
  NOTIFICATION_SETTINGS,
} = helpers;

export const useNotification = () => useContext(NotificationContext);

function NotificationProvider({ children }) {
  const notificationAlertRef = useRef(null);
  const { t } = useTranslation();

  function notify(type, message) {
    const alertType =
      type === NOTIFICATION_TYPE.ERROR
        ? NOTIFICATION_TYPE.DANGER
        : type;

    const titleFallbacks = {
      error: "Error",
      danger: "Error",
      success: "Success",
      warning: "Warning",
      info: "Info",
    };
    const fallbackTitle = titleFallbacks[type] || "Info";
    const title = t(`toast.title.${type}`, fallbackTitle);

    notificationAlertRef.current?.notificationAlert({
      place: NOTIFICATION_PLACE.BOTTOM_RIGHT,
      type: alertType,
      autoDismiss: NOTIFICATION_SETTINGS.AUTO_DISMISS,
      message: (
        <div className="d-flex align-items-center">
          <div className="icon icon-shape icon-sm text-white mr-3 rounded-circle d-flex justify-content-center align-items-center">
            <i className={NOTIFICATION_SETTINGS.ICON} />
          </div>
          <div className="text-left">
            <strong className="d-block mb-1">{title}</strong>
            <span>{message}</span>
          </div>
        </div>
      ),
    });
  }

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <NotificationAlert ref={notificationAlertRef} />
    </NotificationContext.Provider>
  );
}

export default NotificationProvider;
